import { gql } from "@apollo/client";

export const DELETE_CSO_WISH = gql`
  mutation deleteCsoWish($csoWishId: ID!) {
    deleteCsoWish(input: { csoWishId: $csoWishId }) {
      csoWish {
        id
        cso {
          id
        }
      }
    }
  }
`;

export const DELETE_SUPPORTER_STATUS = gql`
  mutation deleteCollaborationStatus($supporterStatusId: ID!) {
    deleteCollaborationStatusAsSupporter(
      input: { collaborationStatusId: $supporterStatusId }
    ) {
      clientMutationId
    }
  }
`;

export const CREATE_CSO_WISH = gql`
  mutation createCsoWish($csoId: ID!) {
    createCsoWish(input: { csoId: $csoId }) {
      csoWish {
        id
        cso {
          id
          name
        }
      }
    }
  }
`;

export const SUPPORTER_FIRST_MESSAGE = gql`
  mutation supporter_first_message(
    $supporter: ID!
    $message: String!
    $idealStartingTime: String
    $collaborationScale: String
    $cso: ID!
    $collaborationNeeds: [ID]!
  ) {
    createSupporterFirstMessage(
      input: {
        supporter: $supporter
        message: $message
        idealStartingTime: $idealStartingTime
        collaborationScale: $collaborationScale
        cso: $cso
        collaborationNeeds: $collaborationNeeds
      }
    ) {
      __typename
      collaborationStatus {
        id
        supporterStatus
        collaborationNeeds {
          edges {
            node {
              title
            }
          }
        }
      }
    }
  }
`;

export const SUPPORTER_SEND_MESSAGE = gql`
  mutation supporter_send_message(
    $collaborationStatusId: ID!
    $message: String!
  ) {
    supporterSendMessage(
      input: {
        collaborationStatusId: $collaborationStatusId
        message: $message
      }
    ) {
      message {
        id
        message
        supporterIsSender
      }
    }
  }
`;

export const CSO_SEND_MESSAGE = gql`
  mutation cso_send_message($collaborationStatusId: ID!, $message: String!) {
    csoSendMessage(
      input: {
        collaborationStatusId: $collaborationStatusId
        message: $message
      }
    ) {
      message {
        id
        message
        supporterIsSender
      }
    }
  }
`;

export const CHANGE_COLLABORATION_STATUS = gql`
  mutation updateCollaborationStatus($collaborationStatus: ID!) {
    updateCollaborationStatus(
      input: {
        collaborationStatusId: $collaborationStatus
        newSupporterStatus: "in_contact"
        newCsoStatus: "in_contact"
      }
    ) {
      collaborationStatus {
        readableCsoStatus
        readableSupporterStatus
      }
    }
  }
`;

export const REJECT_OFFER = gql`
  mutation rejectOffer($collaborationStatus: ID!, $message: String!) {
    rejectOffer(
      input: { collaborationStatusId: $collaborationStatus, message: $message }
    ) {
      collaborationStatus {
        supporterStatus
        csoStatus
      }
    }
  }
`;

export const SUPPORTER_SEND_INVITATION = gql`
  mutation supporter_send_interview_invitaion(
    $collaborationStatus: ID!
    $tool: String!
    $url: String!
    $message: String!
    $candidateDate1: DateTime!
    $candidateDate2: DateTime!
    $candidateDate3: DateTime
    $candidateDate4: DateTime
    $candidateDate5: DateTime
  ) {
    supporterSendInterviewInvitation(
      input: {
        collaborationStatusId: $collaborationStatus
        tool: $tool
        url: $url
        message: $message
        candidateDate1: $candidateDate1
        candidateDate2: $candidateDate2
        candidateDate3: $candidateDate3
        candidateDate4: $candidateDate4
        candidateDate5: $candidateDate5
      }
    ) {
      interviewInvitation {
        supporterIsSender
      }
    }
  }
`;

export const SUPPORTER_DELETE_MESSAGE = gql`
  mutation deleteSupporterMessage($collaborationStatusId: ID!) {
    deleteCollaborationStatusAsSupporter(
      input: { collaborationStatusId: $collaborationStatusId }
    ) {
      collaborationStatus {
        id
        csoStatus
        supporterStatus
      }
    }
  }
`;

export const CSO_DELETE_MESSAGE = gql`
  mutation deleteCSOMessage($collaborationStatusId: ID!) {
    deleteCollaborationStatusAsCso(
      input: { collaborationStatusId: $collaborationStatusId }
    ) {
      collaborationStatus {
        id
        csoStatus
        supporterStatus
      }
    }
  }
`;

export const CSO_SEND_INVITATION = gql`
  mutation cso_send_interview_invitation(
    $collaborationStatus: ID!
    $tool: String!
    $url: String!
    $message: String!
    $candidateDate1: DateTime!
    $candidateDate2: DateTime!
    $candidateDate3: DateTime
    $candidateDate4: DateTime
    $candidateDate5: DateTime
  ) {
    csoSendInterviewInvitation(
      input: {
        collaborationStatusId: $collaborationStatus
        tool: $tool
        url: $url
        message: $message
        candidateDate1: $candidateDate1
        candidateDate2: $candidateDate2
        candidateDate3: $candidateDate3
        candidateDate4: $candidateDate4
        candidateDate5: $candidateDate5
      }
    ) {
      interviewInvitation {
        supporterIsSender
      }
    }
  }
`;

export const ANSWER_ACCEPT_INVITATION = gql`
  mutation select_ineterview_date(
    $interviewInvitationId: ID!
    $interviewDate: DateTime!
    $message: String
  ) {
    selecctInterviewDate(
      input: {
        interviewInvitationId: $interviewInvitationId
        interviewDate: $interviewDate
        message: $message
      }
    ) {
      collaborationStatus {
        id
        supporterStatus
        csoStatus
        interviewDetail {
          decidedInterviewDate
        }
      }
    }
  }
`;

export const ANSWER_DENY_INVITATION = gql`
  mutation cansel_interview($interviewInvitationId: ID!) {
    canselInterviewInvitation(
      input: { interviewInvitationId: $interviewInvitationId }
    ) {
      collaborationStatus {
        id
        supporterStatus
        csoStatus
        interviewDetail {
          decidedInterviewDate
        }
      }
    }
  }
`;

export const ANSWER_REJECT_INVITATION = gql`
  mutation reject_interview_invitation(
    $collaborationStatusId: ID!
    $message: String!
  ) {
    rejectOffer(
      input: {
        collaborationStatusId: $collaborationStatusId
        message: $message
      }
    ) {
      collaborationStatus {
        supporterStatus
        csoStatus
      }
    }
  }
`;

export const SAVE_SEARCH_LOG = gql`
  mutation createSearchCsoLog(
    $title: String!
    $memo: String
    $freeWord: String
    $country: String
    $activityFields: [ID!]
    $collaborationNeeds: [ID!]
    $csoNetworks: [ID!]
    $csoThirdPartyCertifications: [ID!]
    $scaleAverages: [ID!]
    $sdgs: [ID!]
    $targets: [ID!]
  ) {
    createSearchCsoLog(
      title: $title
      memo: $memo
      freeWord: $freeWord
      country: $country
      activityFields: $activityFields
      collaborationNeeds: $collaborationNeeds
      networks: $csoNetworks
      thirdPartyCertifications: $csoThirdPartyCertifications
      revenueCategory: $scaleAverages
      sdgs: $sdgs
      targets: $targets
    ) {
      searchCsoLog {
        id
        title
        memo
      }
    }
  }
`;

export const DELETE_SEARCH_LOG = gql`
  mutation deleteSearchCsoLog($searchCsoLogId: ID!) {
    deleteSearchCsoLog(input: { searchCsoLogId: $searchCsoLogId }) {
      success
    }
  }
`;

export const ADD_SUPPORTER_MEMBER = gql`
  mutation supporterCreateRole(
    $email: String!
    $permission: String!
    $supporterId: ID!
  ) {
    supporterCreateRole(
      email: $email
      permission: $permission
      supporterId: $supporterId
    ) {
      result
    }
  }
`;

export const DELETE_SUPPORTER_MEMBER = gql`
  mutation deleteSupporterRole($roleId: ID!) {
    supporterDeleteRole(input: { roleId: $roleId }) {
      role {
        id
      }
    }
  }
`;
